// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__H9RwS","container":"styles_container__fwJ8d","title":"styles_title__35y-l","wrapper":"styles_wrapper__2rsPk","answer":"styles_answer__2LBzf"};